import React, { useEffect, useState } from "react";
import ProductsandLabelsComponent from "../../components/ProductsandLabels/ProductsandLabels";

const ProductsandLabels = () => {
  return <ProductsandLabelsComponent />;
};

export default ProductsandLabels;
